import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { transitions as getTransitions } from 'polished';
var easings = ['easeInOut', 'easeOut', 'easeIn', 'sharp'];
var durations = ['shortest', 'shorter', 'short', 'standard', 'complex', 'enteringScreen', 'leavingScreen'];

function getTransition(properties, delay, easing, duration) {
  return function (_ref) {
    var theme = _ref.theme;
    var transition = "".concat(theme.transitions.duration[duration], "ms ").concat(theme.transitions.easing[easing], " ").concat(delay, "ms");
    return getTransitions(properties, transition);
  };
}

function getDurations(properties, delay, easing) {
  return durations.reduce(function (acc, duration) {
    return Object.assign(Object.assign({}, acc), _defineProperty({}, duration, function () {
      return getTransition(properties, delay, easing, duration);
    }));
  }, {});
}

function easingFunctions(properties, delay) {
  return easings.reduce(function (acc, easing) {
    return Object.assign(Object.assign({}, acc), _defineProperty({}, easing, function () {
      return getDurations(properties, delay, easing);
    }));
  }, {});
}

export function transitions(properties) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return easingFunctions(properties, delay);
}